import * as firebase from 'firebase/app';
import Instructor from '../models/Instructor.js';
require('firebase/firestore');
require('firebase/storage');

const state = {
  instructors: [],
  instructorToEdit: {}
};

const getters = {
  getInstructors: state => state.instructors,
  getInstructorToEdit: state => state.instructorToEdit
};

const actions = {
  getAllInstructors({
    commit
  }) {
    firebase.firestore().collection("instructors").orderBy("priority").onSnapshot(
      snapshot => {
        commit("setLoading", true);

        let instructors = [];
        snapshot.forEach(doc => {
          let i = new Instructor(doc.id, doc.data().nameFirst, doc.data().nameLast, doc.data().bio, doc.data().priority, null, doc.data().imageUrl, doc.data().fullPath, doc.data().created, doc.data().modified);
          instructors.push(i);
        });
        commit("setInstructors", instructors);
        commit("setLoading", false);
      }, error => {
        commit("setLoading", false);
        console.error(error);
      }
    );
  },
  addInstructor({
    commit
  }, instructor) {
    let id = 0;

    firebase.firestore().collection("instructors").add({
        nameFirst: instructor.nameFirst,
        nameLast: instructor.nameLast,
        bio: instructor.bio,
        priority: Number.parseInt(instructor.priority),
        created: instructor.created,
        modified: instructor.modified
      })
      .then(docRef => {
        id = docRef.id;
        console.log("Instructor added with ID: ", id);
        const fileName = instructor.image.name;
        const ext = fileName.slice(fileName.lastIndexOf("."));
        return firebase.storage().ref("instructors/" + id + ext).put(instructor.image);
      })
      .then(fileData => {
        console.log("Uploaded image.");
        let url = fileData.metadata.downloadURLs[0];
        return firebase.firestore().collection("instructors").doc(id).update({
          imageUrl: url,
          fullPath: fileData.metadata.fullPath
        });
      })
      .then(() => {
        console.log("Updated instructor: ", id);
      })
      .catch(error => {
        console.error(error);
      });
  },
  editInstructor({
    commit
  }, instructor) {
    firebase.firestore().collection("instructors").doc(instructor.id).update({
      bio: instructor.bio,
      nameFirst: instructor.nameFirst,
      nameLast: instructor.nameLast,
      priority: Number.parseInt(instructor.priority),
      modified: new Date().toISOString()
    }).then(docRef => {
      console.log("Instructor " + instructor.id + " has been updated.");
    }).catch(error => {
      console.error(error);
    });
  },
  deleteInstructor({
    commit
  }, instructor) {
    let imageRef = firebase.storage().ref().child(instructor.fullPath);

    imageRef.delete().then((result) => {
      console.log("Deleted image");
      return firebase.firestore().collection("instructors").doc(instructor.id).delete();
    }).then((result) => {
      console.log("Deleted instructor");
    }).catch(error => {
      console.error(error);
    });
  }
};

const mutations = {
  setInstructors(state, instructors) {
    state.instructors = instructors;
  },
  setInstructorToEdit(state, instructor) {
    state.instructorToEdit = instructor;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};